/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElDialog as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElSwitch as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4204947a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "share-box"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "dialog-footer"
};
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { apiUsdkSwitchConfGetSwitchList, apiUsdkSwitchConfSaveSwitch } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'configShare',
  emits: ['ok'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    const status = ref('0');
    const sharePlat = [{
      key: 'QQ',
      value: 'qq',
      icon: require('@/assets/login/qq.png')
    }, {
      key: 'QQ空间',
      value: 'qqs',
      icon: require('@/assets/login/qqs.png')
    }, {
      key: '微信',
      value: 'wx',
      icon: require('@/assets/login/wechat.png')
    }, {
      key: '微信朋友圈',
      value: 'wxs',
      icon: require('@/assets/login/wxs.png')
    }, {
      key: '新浪',
      value: 'sina',
      icon: require('@/assets/login/sina.png')
    }, {
      key: '截图',
      value: 'shot',
      icon: require('@/assets/login/shot.png')
    }];
    const dict = ['qq', 'qqs', 'wx', 'wxs', 'sina', 'shot'];
    const selected = ref([]);
    const channel = ref({
      name: ''
    });
    const gid = ref();
    const loading = ref(false);
    const confirmLoading = ref(false);
    const handleChange = (val, item) => {
      if (val) {
        selected.value.push(item.value);
      } else {
        selected.value = selected.value.filter(key => key != item.value);
      }
    };
    const getConf = (cid, gid) => {
      loading.value = true;
      apiUsdkSwitchConfGetSwitchList({
        cid,
        gid
      }).then(res => {
        if (res.code === 0) {
          let data = res.data[0];
          if (data) {
            status.value = data.status_19;
            if (data.condition_19) {
              let condition = JSON.parse(data.condition_19);
              for (let k in condition) {
                if (condition[k]) {
                  selected.value.push(k);
                }
              }
            }
          }
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const emits = __emit;
    const handleOk = () => {
      let params = {
        cid: channel.value.cid,
        gid: gid.value,
        sw_key: 'sw_share',
        sw_status: status.value,
        sw_condition: {}
      };
      if (selected.value.length) {
        dict.forEach(d => {
          params.sw_condition[d] = selected.value.includes(d) ? 1 : 0;
        });
      }
      params.sw_condition = JSON.stringify(params.sw_condition);
      confirmLoading.value = true;
      apiUsdkSwitchConfSaveSwitch(params).then(res => {
        if (res.code === 0) {
          emits('ok');
          handleClose();
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = payload => {
      dialogVisible.value = true;
      getConf(payload.channel.cid, payload.gid);
      gid.value = payload.gid;
      channel.value = payload.channel;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_switch = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_dialog = __unplugin_components_3;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: `${_unref(channel).name}分享开关管理`,
        width: "600px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleOk())
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form_item, {
          label: "分享管理",
          "label-col": {
            span: 4
          }
        }, {
          default: _withCtx(() => [_createVNode(USwitch, {
            modelValue: _unref(status),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(status) ? status.value = $event : null),
            valArr: ['0', '1']
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _unref(status) === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sharePlat, item => {
          return _createElementVNode("div", {
            class: "share-item",
            key: item.value
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
            src: item.icon,
            alt: ""
          }, null, 8, _hoisted_3), _createElementVNode("div", null, _toDisplayString(item.key) + ":", 1)]), _createVNode(_component_el_switch, {
            onChange: $event => handleChange($event, item),
            "model-value": _unref(selected).includes(item.value)
          }, null, 8, ["onChange", "model-value"])]);
        }), 64))])) : _createCommentVNode("", true)])), [[_directive_loading, _unref(loading)]])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});